var React = require('react');

function Blob1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M50.2244 0.000827829C70.4843 -0.0997046 91.1128 8.95298 97.7021 28.9919C104.599 49.9663 95.3351 72.3399 78.4021 85.6923C60.3879 99.8973 35.7807 106.065 17.5049 92.2308C-0.85319 78.3339 -3.77042 51.6786 4.11316 29.4563C11.0401 9.93064 30.313 0.0996311 50.2244 0.000827829Z","fill":"#E8E8E8"}));
}

Blob1.defaultProps = {"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none"};

module.exports = Blob1;

Blob1.default = Blob1;
